// extracted by mini-css-extract-plugin
export default {"button":"LinkButton__button--05PRnG"};